import { render } from "./SpecialList.vue?vue&type=template&id=ca869f00&ts=true"
import script from "./SpecialList.vue?vue&type=script&lang=ts"
export * from "./SpecialList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__